import styled from '@emotion/styled';
import React from 'react';
import { getUGCPropsFromData } from 'src/components/sections/ugc/ugc.data';
import { IPageProps } from '../../../../interfaces/IPages';
import { IUGCProps, UGC } from '../../../components/sections/ugc/ugc';
import { sectionNames } from '../../../constants/shipLanding';
import { LocaleConfigContext } from '../../../contexts/locale-config/locale-config';
import { IRefs } from '../../../hooks/use-element-on-screen/use-element-on-screen';
import { CabinMod } from '../../../modules/cabin-mod';
import { HighlightsMod } from '../../../modules/highlights-mod';
import { OfferTeaserMod } from '../../../modules/offer-teaser-mod';
import { OverviewMod } from '../../../modules/overview-mod';
import { ShipAmenitiesMod } from '../../../modules/ship-amenities-mod';
import { ShipContactMod } from '../../../modules/ship-contact-mod';
import { ShipDetailsMod } from '../../../modules/ship-details-mod';
import { ShipLivePositionMod } from '../../../modules/ship-live-position-mod';
import { mediaQueries } from '../../../style/global-style';

const SectionWrapper = styled.div`
    width: 100%;
    margin-bottom: ${({ theme }) => theme.spacing.landingComponent.small};
    @media ${mediaQueries.tabletAndUp} {
        margin-bottom: ${({ theme }) => theme.spacing.landingComponent.medium};
    }
    @media ${mediaQueries.desktopAndUp} {
        margin-bottom: ${({ theme }) => theme.spacing.landingComponent.large};
    }
`;

const HighlightsSectionWrapper = styled.div`
    background-color: ${({ theme }) => theme.colorsUnifications.white[100]};
    @media ${mediaQueries.phone} {
        padding-top: 30px;
    }
    @media ${mediaQueries.tabletAndUp} {
        margin-top: -42px;
    }
`;

const ShipPageSections = ({ pageProps, refs }: { pageProps: IPageProps; refs: IRefs }) => {
    const localeConfig = React.useContext(LocaleConfigContext);
    const ugcProps = getUGCPropsFromData({
        ...pageProps,
        ugcSlug: localeConfig.slugs.ugc,
    }) as IUGCProps;
    return (
        <>
            <HighlightsSectionWrapper ref={refs[sectionNames.highlights]}>
                <HighlightsMod {...pageProps} />
            </HighlightsSectionWrapper>
            <SectionWrapper ref={refs[sectionNames.offerTeaser]}>
                <OfferTeaserMod {...pageProps} />
            </SectionWrapper>
            <SectionWrapper ref={refs[sectionNames.overview]}>
                <OverviewMod {...pageProps} />
            </SectionWrapper>
            <SectionWrapper ref={refs[sectionNames.shipLivePosition]}>
                <ShipLivePositionMod {...pageProps} />
            </SectionWrapper>
            <SectionWrapper>
                <ShipDetailsMod {...pageProps} />
            </SectionWrapper>
            <SectionWrapper ref={refs[sectionNames.cabin]}>
                <CabinMod {...pageProps} />
            </SectionWrapper>
            <SectionWrapper>
                <ShipContactMod {...pageProps} />
            </SectionWrapper>
            <SectionWrapper ref={refs[sectionNames.reviews]}>
                <UGC {...ugcProps} />
            </SectionWrapper>
            <SectionWrapper ref={refs[sectionNames.shipAmenities]}>
                <ShipAmenitiesMod {...pageProps} />
            </SectionWrapper>
        </>
    );
};

export default React.memo(ShipPageSections);
